<template>
  <div class="content">
    <div class="date">{{ date }}</div>
    <h4>{{ title }}</h4>
    <hr width="100%">
    <p>
      <slot></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'notice-section',
  props: {
    title: String,
    date: String
  },
}
</script>

<style scoped>
.content{
  margin: 25px 20px;
  border: 1px #ccc solid;
}
.date{
  font-size: 12px;
  text-align: left;
  margin: 0 0 0 5px;
}
h4{
  margin: 0;
}
p{
  text-align: left;
}
</style>
